export default __webpack_public_path__ + "static/glass-3-ca45726d8e04d24cf09837bd63d1b89e.jpg";